import { motion } from "framer-motion";
import { useLanguage } from "@/i18n/LanguageContext";

const ease = [0.22, 1, 0.36, 1] as const;

const LifestyleClosing = () => {
  const { t } = useLanguage();

  return (
    <section className="py-32 md:py-44 lg:py-52 bg-secondary/40">
      <div className="mx-auto px-8 max-w-3xl text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1.6, ease }}
        >
          <p className="font-body text-muted-foreground text-sm md:text-base leading-[2] mb-12">
            {t("Designed around your time.", "Ontworpen rondom uw tijd.")}
            <br />{t("Handled without interruption.", "Geregeld zonder onderbreking.")}
          </p>
          <p className="font-display text-4xl md:text-6xl lg:text-7xl text-foreground leading-[1] tracking-[0.15em] uppercase">
            Arzani
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default LifestyleClosing;
